import type { Membership, MembershipManagement } from "./api.ts";

/** Return whether a membership can administer workspace-owned resources. */
export function canAdministerWorkspace(role: Membership["role"]): boolean {
  return role === "owner" || role === "admin";
}

/** Return whether AppNotes can administer this workspace's members. */
export function canManageMembers(
  role: Membership["role"],
  management: MembershipManagement | null,
): boolean {
  return canAdministerWorkspace(role) && management === "appnotes";
}

/** Return whether the actor can change or remove a specific member. */
export function canAdministerMember(input: {
  readonly actorRole: Membership["role"];
  readonly actorUserId: string;
  readonly management: MembershipManagement | null;
  readonly memberRole: Membership["role"];
  readonly memberUserId: string;
}): boolean {
  return (
    canManageMembers(input.actorRole, input.management) &&
    input.actorUserId !== input.memberUserId &&
    input.memberRole !== "owner"
  );
}

/** Return whether a user can modify content owned by another principal. */
export function canModifyAuthoredContent(input: {
  readonly role: Membership["role"];
  readonly userId: string;
  readonly authorId: string;
}): boolean {
  return canAdministerWorkspace(input.role) || input.userId === input.authorId;
}

/** Resolved notes are read-only until a member reopens them. */
export function canReplyToNote(state: "open" | "resolved"): boolean {
  return state === "open";
}
